import { useState } from 'react';

import { TariffsSettings } from './settings/TariffsSettings';
import { DictSettings } from './settings/DictSettings';
import { ClientStatusesSettings } from './settings/ClientStatusesSettings';
import { SalesFunnelSettings } from './settings/SalesFunnelSettings';
import { NotificationsSettings } from './settings/NotificationsSettings';
import { FinanceSettings } from './settings/FinanceSettings';
import { TelegramGroupsSettings } from './settings/TelegramGroupsSettings';
import { ApiKeysSettings } from './settings/ApiKeysSettings';

const TABS = [
  { id: 'client_statuses', label: 'Статусы клиентов' },
  { id: 'sales_funnel', label: 'Воронка продаж' },
  { id: 'order_statuses', label: 'Статусы заказов' },
  { id: 'tariffs', label: 'Тарифы' },
  { id: 'expenditure', label: 'Группы расходов' },
  { id: 'notifications', label: 'Оповещения' },
  { id: 'finance', label: 'Финансы' },
  { id: 'telegram_groups', label: 'Telegram-группы' },
  { id: 'api_keys', label: 'API KEY' },
];

export function SettingsPage() {
  const [tab, setTab] = useState(TABS[0].id);

  return (
    <section>
      <div className="page-header">
        <h1>Настройки</h1>
      </div>

      <div className="tabs">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={tab === t.id ? 'active' : ''}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'client_statuses' && <ClientStatusesSettings />}
      {tab === 'sales_funnel' && <SalesFunnelSettings />}
      {tab === 'order_statuses' && (
        <DictSettings
          group="order_statuses"
          title="Статусы заказов / продаж"
          help="Статусы для заказов и продаж (новый, оплачен, отменён и т.д.)."
        />
      )}
      {tab === 'tariffs' && <TariffsSettings />}
      {tab === 'expenditure' && (
        <DictSettings
          group="expenditure"
          title="Группы расходов"
          help="Категории для расходов филиала (аренда, зарплата, реклама и т.д.)."
        />
      )}
      {tab === 'notifications' && <NotificationsSettings />}
      {tab === 'finance' && <FinanceSettings />}
      {tab === 'telegram_groups' && <TelegramGroupsSettings />}
      {tab === 'api_keys' && <ApiKeysSettings />}
    </section>
  );
}
